export default __webpack_public_path__ + "static/media/Logo_Primario_Blanco.7d09ae96.svg";